<template>
    <div id="dashboard">
        <loader :loading="loading_status"></loader>
        <div class="row"  v-if="!loading_status">
            <div class="col-lg-12">
                <div class="row" v-show="is_admin">
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <quick-stats :data="dashboard_data"></quick-stats>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="content-body chart-container">
                            <axis-chart :data="chart_data"></axis-chart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import QuickStats from "./modules/QuickStats";
    import AxisChart from "../common/lib/charts/AxisChart";
    import { mapActions, mapGetters } from 'vuex';
    import Loader from '../common/controls/Loader'

    export default{
        name: 'dashboard',
        data() {
            return {
                chart_data: {
                    name: 'Heti cikkek száma',
                    unit: 'db.',
                    items: [], //this.dashboard_data.weekly_post_visitors
                }
            }
        },
        components: {
            AxisChart,
            QuickStats,
            Loader
        },
        computed: {
           ...mapGetters([
               'user',
               'dashboard',
               'loading',
           ]),
            loading_status: {
                get: function() {
                    return this.loading ? this.loading : false;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            is_admin() {
                return this.user.is_administrator;
            },
            dashboard_data: {
                get: function() {
                    return this.dashboard;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
        },
        methods: {
            ...mapActions([
                'getDashboard',
            ]),
        },
        mounted() {
            this.getDashboard({});
        },
        watch: {
            dashboard: {
                handler: function(newVal) {
                    this.dashboard_data = newVal;
                    this.chart_data.items = newVal.weekly_post_visitors;
                },
                deep: true,
            }
        }
    }
</script>

<style scoped lang="scss">
    .chart-container {
        margin: 25px 10px 10px 10px;
    }
    #axis-chart {
        height: 350px;
    }
</style>
